/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import axios from "axios"

export default {
  data: () => ({
    statusChangeLoading: false
  }),
  methods: {
    _updateItems(ids, newItems) {
      for (const id of ids) {
        const indx = this.items.findIndex(item => item.id === id)
        const newItem = newItems.find(item => item.id === id)
        if (indx !== -1 && newItem) {
          this.$set(this.items, indx, newItem)
        } else {
          console.error("Unable to locate item in the table.", indx, newItem)
        }
      }
    },
    saveBulkStatusChange(evt, url, itemsFunc) {
      this.statusChangeLoading = true
      this.saveStatusChange(
        evt,
        this.selectedItems.map(item => item.id),
        url,
        itemsFunc
      ).finally(() => {
        this.selectedItems = []
        this.statusChangeLoading = false
      })
    },
    saveStatusChange(
      { note, selectedStatus },
      ids,
      url,
      itemsFunc = data => data
    ) {
      return axios
        .put(
          url.replace(":ids", ids.join(",")).replace(":batchId", this.batchId),
          {
            newStatus: selectedStatus,
            comment: note
          }
        )
        .then(response => {
          this._updateItems(ids, itemsFunc(response.data))
          if (this._updateGroups) this._updateGroups(response.data)

          // This is using the importers debouncedsearch function to refresh table
          this.debouncedSearch()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/statusChange.js